export default __webpack_public_path__ + "static/12-84a3a1b9125806f60ca9330a93443bf9.jpg";